import React from 'react';
import {Center} from 'src/design/atoms/Center';
import {CheckIcon, IconSize} from 'src/design/atoms/icons/CommonIcons';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {ThemeIcon} from 'src/design/atoms/ThemeIcon';

export interface AllClearStateProps {
  message?: string;
}

/**
 * Centered green check with a dimmed message, for a work queue with nothing left to do.
 * @registry Green-check "You're all caught up!" empty state for task/training queues.
 */
export const AllClearState: React.FC<AllClearStateProps> = ({
  message = "You're all caught up!",
}) => (
  <Center py="xl">
    <Stack align="center" gap="sm">
      <ThemeIcon size={48} radius="xl" color="green" variant="light">
        <CheckIcon size={IconSize.xxl} />
      </ThemeIcon>
      <Text c="dimmed" size="sm">
        {message}
      </Text>
    </Stack>
  </Center>
);
